import types from './types';

function handleLoginRequest() {
  return {
    type: types.HANDLE_LOGIN_REQUEST,
  };
}

function handleLoginFailure(error) {
  return {
    type: types.HANDLE_LOGIN_FAILURE,
    payload: {
      error,
    },
  };
}

function handleLoginSuccess(response) {
  return {
    type: types.HANDLE_LOGIN_SUCCESS,
    payload: {
      ...response,
    },
  };
}

function handleRefreshTokenRequest() {
  return {
    type: types.HANDLE_REFRESH_TOKEN_REQUEST,
  };
}
function handleRefreshTokenFailure(error) {
  return {
    type: types.HANDLE_REFRESH_TOKEN_FAILURE,
    payload: {
      error,
    },
  };
}
function handleRefreshTokenSuccess(response) {
  return {
    type: types.HANDLE_REFRESH_TOKEN_SUCCESS,
    payload: {
      ...response,
    },
  };
}

function handleLogout() {
  return {
    type: types.HANDLE_LOGOUT,
  };
}

function loadUserFromToken(token) {
  return {
    type: types.LOAD_USER_FROM_TOKEN,
    payload: {
      token,
    },
  };
}

function forgotPasswordRequest() {
  return {
    type: types.FORGOT_PASSWORD_REQUEST,
  };
}
function forgotPasswordFailure(error) {
  return {
    type: types.FORGOT_PASSWORD_FAILURE,
    payload: {
      error,
    },
  };
}
function forgotPasswordSuccess(response) {
  return {
    type: types.FORGOT_PASSWORD_SUCCESS,
    payload: {
      ...response,
    },
  };
}

function recoverPasswordRequest() {
  return {
    type: types.RECOVER_PASSWORD_REQUEST,
  };
}
function recoverPasswordFailure(error) {
  return {
    type: types.RECOVER_PASSWORD_FAILURE,
    payload: {
      error,
    },
  };
}
function recoverPasswordSuccess(response) {
  return {
    type: types.RECOVER_PASSWORD_SUCCESS,
    payload: {
      ...response,
    },
  };
}

export default {
  handleLoginRequest,
  handleLoginFailure,
  handleLoginSuccess,

  handleRefreshTokenRequest,
  handleRefreshTokenFailure,
  handleRefreshTokenSuccess,

  handleLogout,

  loadUserFromToken,

  forgotPasswordRequest,
  forgotPasswordFailure,
  forgotPasswordSuccess,

  recoverPasswordRequest,
  recoverPasswordFailure,
  recoverPasswordSuccess,
};
